const validatejs = require("validate.js");

const constraints = {
  companyName: {
    presence: {
      message: "Zorunlu alan doldurulmalıdır.",
    },
    length: {
      minimum: 4,
      maximum: 40,
      message: "4 ile 40 karakter arasında olmalıdır.",
    },
  },
  name: {
    presence: {
      message: "Zorunlu alan doldurulmalıdır.",
    },
    length: {
      minimum: 4,
      maximum: 40,
      message: "4 ile 40 karakter arasında olmalıdır.",
    },
  },
  phone: {
    presence: {
      message: "Zorunlu alan doldurulmalıdır.",
    },
    length: {
      is: 10,
      message: "10 haneli olmalıdır.",
    },
  },
  email: {
    email: {
      message: "Lütfen geçerli bir E-Posta adresi giriniz.",
    },
    presence: {
      message: "Zorunlu alan doldurulmalıdır.",
    },
  },
  password: {
    presence: {
      message: "Zorunlu alan doldurulmalıdır.",
    },
    length: {
      minimum: 6,
      message: "En az 6 karakter olmalıdır.",
    },
  },
  passwordForSignin: {
    presence: {
      message: "Zorunlu alan doldurulmalıdır.",
    },
  },
  message: {
    presence: {
      message: "Zorunlu alan doldurulmalıdır.",
    },
    length: {
      minimum: 1,
      message: "En az 1 karakter olmalıdır.",
    },
  },
  membershipContract: {
    presence: {
      message: "",
    },
  },
  isKvkkApproved: {
    presence: {
      message: "",
    },
  },
  cityId: {
    presence: {
      message: "*Zorunlu alan doldurulmalıdır.",
    },
  },
  districtId: {
    presence: {
      message: "*Zorunlu alan doldurulmalıdır.",
    },
  },
};

const validate = (field) => {
  return validatejs(field, constraints, { fullMessages: false });
};

export default validate;
